import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    initial: 'M',
    name: 'María José L.',
    role: 'Pediatra en Consultorio Privado',
    text: 'El Sistema PRO Pediatría cambió completamente mi forma de documentar. Los protocolos de consulta y las plantillas de historia clínica me dieron la estructura que siempre necesité y nunca tuve. Totalmente recomendado para cualquier pediatra que quiera ejercer con más orden y tranquilidad.',
    color: 'bg-blue-100 text-blue-700'
  }, {
    initial: 'P',
    name: 'Pablo M.',
    role: 'Pediatra en Centro de Salud',
    text: 'Excelente material. Muy práctico y directo al punto. El módulo de comunicación con padres me ayudó enormemente a manejar situaciones difíciles que antes me generaban mucha incertidumbre. Una herramienta que no sabía que necesitaba.',
    color: 'bg-emerald-100 text-emerald-700'
  }, {
    initial: 'S',
    name: 'Sofía R.',
    role: 'Médica Generalista con pacientes pediátricos',
    text: 'Lo que más valoro es el módulo de desarrollo infantil por etapas. Tener todo unificado y ordenado por edad me ahorró horas de búsqueda en cada consulta de control. Una inversión que vale cada centavo desde el primer día.',
    color: 'bg-purple-100 text-purple-700'
  },
  // Additional 5 testimonials
  {
    initial: 'C',
    name: 'Carolina V.',
    role: 'Neonatóloga',
    text: 'Las plantillas de derivación y seguimiento interdisciplinario son una maravilla. Me permiten comunicarme con otros especialistas de forma clara y sin perder tiempo. Un recurso invaluable para la práctica diaria.',
    color: 'bg-pink-100 text-pink-700'
  }, {
    initial: 'M',
    name: 'Martín G.',
    role: 'Residente de Pediatría',
    text: 'Como residente, este sistema me dio la seguridad que me faltaba en las guardias. Los protocolos de urgencia son claros y van directo al grano. Lo recomiendo a todos mis compañeros.',
    color: 'bg-indigo-100 text-indigo-700'
  }, {
    initial: 'L',
    name: 'Luciana D.',
    role: 'Enfermera Pediátrica',
    text: 'El banco de actividades de estimulación temprana es fantástico. Ahora puedo darle a los padres herramientas concretas y fáciles de aplicar en casa. Las familias lo agradecen muchísimo.',
    color: 'bg-yellow-100 text-yellow-700'
  }, {
    initial: 'F',
    name: 'Fernando A.',
    role: 'Pediatra en Hospital Público',
    text: 'En el hospital el tiempo es oro. Con estas plantillas reduzco el tiempo de escritura a la mitad sin perder calidad en la historia clínica. Es exactamente lo que buscaba para optimizar mi tiempo.',
    color: 'bg-red-100 text-red-700'
  }, {
    initial: 'V',
    name: 'Valentina S.',
    role: 'Médica de Familia',
    text: 'La guía de comunicación difícil me salvó en más de una ocasión. Te da las palabras justas para momentos delicados. Todo el sistema está pensado desde la realidad del consultorio, no desde la teoría.',
    color: 'bg-teal-100 text-teal-700'
  }];
  return <section id="testimonios" className="py-14 bg-gray-50" data-id="element-187">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3" data-id="element-190">
            Lo que dicen los profesionales
          </h2>
          <div className="w-24 h-1 bg-emerald-500 mx-auto rounded-full" data-id="element-191"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-192">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.04,
          duration: 0.4
        }} className="bg-white p-5 rounded-xl shadow-md border border-gray-100 relative" data-id="element-193">
              <Quote className="absolute top-4 right-4 w-6 h-6 text-emerald-100" data-id="element-194" />
              <p className="text-gray-600 italic mb-5 relative z-10 leading-relaxed text-sm" data-id="element-195">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-196">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg ${testimonial.color}`} data-id="element-197">
                  {testimonial.initial}
                </div>
                <div data-id="element-198">
                  <h4 className="font-bold text-gray-900 text-sm" data-id="element-199">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-emerald-600 font-medium" data-id="element-200">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}